import React from 'react'
import LogoAzul from '../../Media/LogoAzul.png'
import { Dialog } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import LanguageToggle from './LanguageToggle'


export default function NavbarSmResp({mobileMenuOpen, setMobileMenuOpen}) {

  const { t } = useTranslation('navbar')

  return (
    <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
        <div className="fixed inset-0 z-[60]" />
        <Dialog.Panel className="fixed inset-y-0 right-0 z-[60] w-full overflow-y-auto bg-white px-6 py-4 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <Link to={'/'} onClick={() => setMobileMenuOpen(false)}>
              <span className="sr-only">{t('logoAlt')}</span>
              <img
              src={LogoAzul}
              alt={t('logoAlt')}
              placeholder='blur'
              className='w-32'
              />
            </Link>
            <div className="flex items-center gap-3">
              <LanguageToggle />
              <button
                type="button"
                className="-m-2.5 rounded-md mr-2 p-2.5 text-gray-700"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="sr-only">{t('closeMenu')}</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                <Link
                  to={'/aboutUs'}
                  onClick={() => setMobileMenuOpen(false)}
                  className="-mx-3 block rounded-lg px-3 py-2 text-base leading-7 text-gray-900 hover:bg-gray-50"
                >
                  {t('nosotros')}
                </Link>
                <Link
                  to={'/soporte'}
                  onClick={() => setMobileMenuOpen(false)}
                  className="-mx-3 block rounded-lg px-3 py-2 text-base leading-7 text-gray-900 hover:bg-gray-50"
                >
                  {t('soporte')}
                </Link>
                <Link
                  to={'/catalogo'}
                  onClick={() => setMobileMenuOpen(false)}
                  className="-mx-3 block rounded-lg px-3 py-2 text-base leading-7 text-gray-900 hover:bg-gray-50"
                >
                  {t('catalogo')}
                </Link>
                <Link
                  to={'/solutions'}
                  onClick={() => setMobileMenuOpen(false)}
                  className="-mx-3 block rounded-lg px-3 py-2 text-base leading-7 text-gray-900 hover:bg-gray-50"
                >
                  {t('rfid')}
                </Link>
                <Link
                  to={'/swrya'}
                  onClick={() => setMobileMenuOpen(false)}
                  className="-mx-3 block rounded-lg px-3 py-2 text-base leading-7 text-gray-900 hover:bg-gray-50"
                >
                  {t('swrya')}
                </Link>
              </div>
              <div className="py-6">
                <Link
                  to={'/contact'}
                  state="demo-swrya"
                  onClick={() => setMobileMenuOpen(false)}
                  className="-mx-3 block rounded-lg px-3 py-2.5 text-base leading-7 text-gray-900 hover:bg-gray-50"
                >
                  {t('solicitarDemo')}
                </Link>
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
  )
}
